const productTypes = {
    QUOTEABLE : 'Quoteable',

    SUBMITABLE : 'Submmitable',

    NA : 'Na'

};

angular.module('gw-um-j2js')
    .constant('productTypes', productTypes);